@if (isNotNullOrUndefined(this.entityGestionEquipe?.id)) {
	<div class="input-container form-ajout-utilisateur">
		<div class="input-equipe rechercher-utilisateur">
			<label for="utilisateur-autocomplete">{{ 'ENTITY_GESTION_EQUIPE.LABEL_AJOUTER_UTILISATEUR' | translate }}</label>
			<div class="container-autocomplete-et-bouton-ajouter">
				<div class="autocomplete-ajout-utilisateur">
					<p-autoComplete
							id="utilisateur-autocomplete"
							[style]="{'width':'100%'}"
							[inputStyle]="{'width':'100%'}"
							[(ngModel)]="utilisateurAAjouter"
							(ngModelChange)="utilisateurAAjouterChange.emit($event)"
							[forceSelection]="forceSelection"
							[showClear]="showClear"
							[suggestions]="utilisateursSuggestions"
							(completeMethod)="rechercherUtilisateurs($event)"
							[optionLabel]="optionLabel"
							[emptyMessage]="emptyMessage">
					</p-autoComplete>
				</div>
				<div class="button-ajouter-utilisateur">
					<p-button
							(onClick)="ajouterUtilisateur.emit()"
							[label]="labelBouttonAjouter"
							[disabled]="isButtonAjouterUtilisateurDisabled()"
							[loading]="loadingAjouterUtilisateur()"></p-button>
				</div>
			</div>
		</div>
	</div>
	@if (isNotNullOrUndefined(this.entityGestionEquipe.membres)) {
		<div class="container-table-utilisateur">
			<p-table #dgUtilisateurs
					 class="table-utilisateur"
					 [value]="this.entityGestionEquipe.membres"
					 selectionMode="multiple"
					 [(selection)]="utilisateursSelectionnes"
					 dataKey="login"
					 (selectionChange)="onSelectionChange($event)"
					 [loading]="loadingTableUtilisateur()"
					 [scrollable]="true"
					 [scrollHeight]="renseignerScrollHeight()"
					 sortField="prenom"
					 [sortOrder]="1">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 3rem">
							<p-tableHeaderCheckbox/>
						</th>
						<th pSortableColumn="prenom">{{ 'ENTITY_GESTION_EQUIPE.TABLE.PRENOM' | translate }}
							<p-sortIcon field="prenom"/>
						</th>
						<th pSortableColumn="nom">{{ 'ENTITY_GESTION_EQUIPE.TABLE.NOM' | translate }}
							<p-sortIcon field="nom"/>
						</th>
					</tr>
					<tr>
						<th></th>
						<th>
							<input class="p-inputtext filtreInput" type="text" (input)="dgUtilisateurs.filter($event.target.value, 'prenom', 'contains')">
						</th>
						<th>
							<input class="p-inputtext filtreInput" type="text" (input)="dgUtilisateurs.filter($event.target.value, 'nom', 'contains')">
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-utilisateur let-rowIndex="rowIndex">
					<tr class="p-selectable-row" [pSelectableRow]="utilisateur" [pSelectableRowIndex]="rowIndex">
						<td>
							<p-tableCheckbox [disabled]="true" [value]="utilisateur"/>
						</td>
						<td>{{ utilisateur.prenom }}</td>
						<td>{{ utilisateur.nom }}</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="3" class="ligne-table-utilisateur-vide">
							{{
								typeEntity === 'equipe' ?
										('EQUIPE.EQUIPE_SANS_UTILISATEUR' | translate) :
										('GROUPE_DE_TRAVAIL.GROUPE_DE_TRAVAIL_SANS_UTILISATEUR' | translate)
							}}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
		<div>
			<p-button [disabled]="isButtonRetirerUtilisateurDisabled()"
					  (onClick)="onRetirerUtilisateurs()"
					  label="{{ 'EQUIPE.BUTTON_RETIRER_UTILISATEURS' | translate }}"/>
		</div>
	}
}
